import { render, staticRenderFns } from "./SlideBanner.vue?vue&type=template&id=6d660ee2&scoped=true"
import script from "./SlideBanner.vue?vue&type=script&lang=js"
export * from "./SlideBanner.vue?vue&type=script&lang=js"
import style0 from "./SlideBanner.vue?vue&type=style&index=0&id=6d660ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d660ee2",
  null
  
)

export default component.exports